import { render, staticRenderFns } from "./CompaniesList.vue?vue&type=template&id=37fbab8c&"
import script from "./CompaniesList.vue?vue&type=script&lang=js&"
export * from "./CompaniesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fbab8c')) {
      api.createRecord('37fbab8c', component.options)
    } else {
      api.reload('37fbab8c', component.options)
    }
    module.hot.accept("./CompaniesList.vue?vue&type=template&id=37fbab8c&", function () {
      api.rerender('37fbab8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/CompaniesList.vue"
export default component.exports